import { useInView } from '@/hooks/useInView';

type Animation =
  | 'fade-up'       // sube desde abajo (default)
  | 'fade-down'     // baja desde arriba
  | 'fade-left'     // entra desde la derecha
  | 'fade-right'    // entra desde la izquierda
  | 'fade'          // solo opacidad
  | 'zoom-in'       // escala desde pequeño
  | 'zoom-up';      // escala + sube

interface Props {
  children: React.ReactNode;
  animation?: Animation;
  delay?: number;       // ms
  duration?: number;    // ms
  threshold?: number;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

const HIDDEN: Record<Animation, React.CSSProperties> = {
  'fade-up':    { opacity: 0, transform: 'translateY(36px)' },
  'fade-down':  { opacity: 0, transform: 'translateY(-28px)' },
  'fade-left':  { opacity: 0, transform: 'translateX(36px)' },
  'fade-right': { opacity: 0, transform: 'translateX(-36px)' },
  'fade':       { opacity: 0 },
  'zoom-in':    { opacity: 0, transform: 'scale(0.92)' },
  'zoom-up':    { opacity: 0, transform: 'translateY(24px) scale(0.95)' },
};

const VISIBLE: React.CSSProperties = {
  opacity: 1,
  transform: 'translateY(0) translateX(0) scale(1)',
};

export default function ScrollReveal({
  children,
  animation = 'fade-up',
  delay = 0,
  duration = 600,
  threshold = 0.1,
  className = '',
  as: Tag = 'div',
}: Props) {
  const [ref, inView] = useInView<HTMLDivElement>({ threshold, rootMargin: '0px 0px -50px 0px' });

  const style: React.CSSProperties = {
    ...(inView ? VISIBLE : HIDDEN[animation]),
    transition: `opacity ${duration}ms cubic-bezier(0.22,1,0.36,1) ${delay}ms, transform ${duration}ms cubic-bezier(0.22,1,0.36,1) ${delay}ms`,
    willChange: 'opacity, transform',
  };

  return (
    // @ts-expect-error dynamic tag
    <Tag ref={ref} className={className} style={style}>
      {children}
    </Tag>
  );
}
